<template>
  <kst-section items-mode class="mt-5">
    <kst-table input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="ItemID"
        :label="HppAdjItemCatalog.DispatchName.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo_Details(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        field="Qty"
        :label="HppAdjItemCatalog.Qty.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        field="HppPerPcs"
        :label="HppAdjItemCatalog.HppPerPcs.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        field="HppTotal"
        :label="HppAdjItemCatalog.HppTotal.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import HppAdjItemCatalog from "../HppAdjItemCatalog.js";
import Model from "../HppAdjModel.js";

export default {
  props: {
    data: Object,
    items: Array
  },
  data: () => ({
    HppAdjItemCatalog: HppAdjItemCatalog,
    Model: Model
  })
}
</script>